<template>
  <div>
    {{ checkin }}
  </div>
</template>

<script>
import * as utils from "@/utils/utils";
import { date2timestamp } from "@/utils/utils";
export default {
  data() {
    return {
      checkin: null,
    };
  },
  beforeMount() {
    this.checkin = utils.dateformat(
      date2timestamp(this.params.data.checkin, true),
      "MM/DD/YYYY"
    );
  },
};
</script>

<style scoped>
</style>
